import React, { useState } from 'react';
import './Home.css';
import TypewriterLine from './TypewriterLine';

const Home = () => {
  const lines = [
    "Visbanking has data from 2.6M people and access to job postings from all banks.",
    "You can find the perfect candidate or directly contact the HR manager of the bank you are applying to.",
    "Experience seamless, innovative recruitment solutions.",
    "Empowering HR teams with real-time updates and smart tools."
  ];
  
  const [currentLine, setCurrentLine] = useState(0);

  return (
    <div className="home-container">
      <h1>Recruitment Application</h1>
      <div className="typewriter-container">
        {lines.map((line, index) => (
          <div key={index}>
            {index === currentLine ? (
              <TypewriterLine 
                text={line} 
                speed={50} 
                onComplete={() => setTimeout(() => {
                  setCurrentLine(prev => prev + 1);
                }, 1000)}
              />
            ) : index < currentLine ? (
              <p className="typewriter-line completed">{line}</p>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
